export default __webpack_public_path__ + "assets/models/f0e245ba93a4234bfcacb47c0a25e738.glb";